(ns teamoesterreich.admin-mode.questionnaire.questionnaire-question-list
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.questionnaire :as d-questionnaire]
            [teamoesterreich.admin-mode.questionnaire.questionnaire-question-detail-form :as question-detail-form]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.arrow-upward :refer [arrow-upward]]
            [reagent-material-ui.icons.arrow-downward :refer [arrow-downward]]
            [reagent-material-ui.icons.insert-photo :refer [insert-photo]]
            [reagent-material-ui.icons.radio-button-checked-two-tone :refer [radio-button-checked-two-tone]]
            [reagent-material-ui.icons.check-box-outline-blank-two-tone :refer [check-box-outline-blank-two-tone]]
            [reagent-material-ui.icons.confirmation-number :refer [confirmation-number]]
            [reagent-material-ui.icons.text-fields :refer [text-fields]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            ))






(defn get-max-index [questions]
  (reduce (fn [c e] (max c (:questionnaireQuestion-index (second e)))) 0 questions))



(defn get-question-by-index [questions index reload-fn]
  (second (first (filter #(= index (:questionnaireQuestion-index (second %))) questions))))
(defn get-question-by-uuid [questions uuid]
  (second (first (filter #(= uuid (:questionnaireQuestion-uuid (second %))) questions))))

(defn >swap-index-upwards [uuid index questions reload-fn]
  (d-questionnaire/>question-save-index uuid (dec index) reload-fn)
  (when-let [uuid (:questionnaireQuestion-uuid  (get-question-by-index questions (dec index) reload-fn))]
    (d-questionnaire/>question-save-index uuid index reload-fn)))

(defn >swap-index-downwards [uuid index questions reload-fn]
  (d-questionnaire/>question-save-index uuid (inc index) reload-fn)
  (when-let [uuid (:questionnaireQuestion-uuid  (get-question-by-index questions (inc index) reload-fn))]
    (d-questionnaire/>question-save-index uuid index reload-fn)))



(defn question-card [question !open-question questions reload-fn]
  (let [!st (r/atom {})
        !show-delete-popup (r/cursor !st [:show-delete-popup])]
    (fn []
      (let [question-uuid (:questionnaireQuestion-uuid question)
            index (:questionnaireQuestion-index question)]
        [mui/card {:style {:margin "3px"} }

         [are-you-sure-modal/are-you-sure-modal !show-delete-popup "Bist du sicher, dass du diese Frage löschen möchtest?" "Löschen"
          #(d-questionnaire/>question-save question-uuid {:questionnaireQuestion-active false} reload-fn)]
         [mui/card-actions
          [mui/icon-button {:onClick #(reset! !open-question question-uuid)} [edit]]
          [mui/icon-button {:onClick #(reset! !show-delete-popup true)} [delete-forever]]
          (when (> index 1)
            [mui/icon-button {:onClick #(>swap-index-upwards question-uuid index questions reload-fn)} [arrow-upward]])
          (when (< index (count questions))
            [mui/icon-button {:onClick #(>swap-index-downwards question-uuid index questions reload-fn)} [arrow-downward]])
          "(MaxPunkte:" (:_questionnaireQuestionnaire-maxPoints question) ")"
          ]
         [mui/card {:style {:display "flex"
                            :flexDirection "row"} }
          [mui/card-media {:component "img"
                           :style {:flex "0 0 200px" :width "200px"}
                           :alt       (str (:questionnaireQuestion-imageUri question))
                           :height    "140"
                           :image     (:questionnaireQuestion-imageUri question)
                           :title     (:questionnaireQuestion-name question)}]

          [mui/card-content {:style {:flex "1 0 400px"}}
           [mui/typography {:variant "h5"} (str (:questionnaireQuestion-question question) )]
           (doall (for [answerOption (sort-by :questionnaireAnswerOption-index (filter (fn [e] (and (:questionnaireAnswerOption-active e) (not= (:questionnaireAnswerOption-type e) "radioOption")))
                                                                                       (clojure.walk/keywordize-keys (:questionnaireQuestion-AnswerOption question))))]
                    ^{:key (str "answerOption-" (:questionnaireAnswerOption-uuid answerOption))}
                    (r/as-element (case (:questionnaireAnswerOption-type answerOption)
                                    "image" [mui/chip {:label (:questionnaireAnswerOption-motiv answerOption) :icon (r/as-element [insert-photo]) :style {:margin "3px 3px 3px 3px"}}]
                                    "radio" [mui/chip {:label (:questionnaireAnswerOption-text answerOption) :icon (r/as-element [radio-button-checked-two-tone]) :style {:margin "3px 3px 3px 3px"}}]
                                    "checkbox" [mui/chip {:label (:questionnaireAnswerOption-text answerOption) :icon (r/as-element [check-box-outline-blank-two-tone]) :style {:margin "3px 3px 3px 3px"}}]
                                    "decimal" [mui/chip {:label (:questionnaireAnswerOption-text answerOption) :icon (r/as-element [confirmation-number]) :style {:margin "3px 3px 3px 3px"}}]
                                    "numeric" [mui/chip {:label (:questionnaireAnswerOption-text answerOption) :icon (r/as-element [confirmation-number]) :style {:margin "3px 3px 3px 3px"}}]
                                    "text" [mui/chip {:label (:questionnaireAnswerOption-hint answerOption) :icon (r/as-element [text-fields]) :style {:margin "3px 3px 3px 3px"}}]
                                    [mui/chip {:label (:questionnaireAnswerOption-text answerOption)
                                               :style {:margin "3px 3px 3px 3px"}}]
                                    ))))

           ]]]
        ))))



(defn get-it []
  (let [!st (r/atom {:tab 0})
        !questionnaire (r/cursor vstate/app-state [:edit-questionnaire :selected-questionnaire])
        !open-question (r/cursor vstate/app-state [:edit-questionnaire :open-question])
        !questions (r/cursor vstate/app-state [:edit-questionnaire :questions])
        !loaded (r/cursor vstate/app-state [:edit-questionnaire :questions-loaded])
        reload-fn #(d-questionnaire/load-question-list)
        !show-add-popup (r/cursor !st [:new-question-popup])
        ]
    (fn []

      (log/debug "question tab get-it" (clj->js @!questionnaire))

      (if-not @!loaded
        (do
          (d-questionnaire/load-question-list #(reset! !loaded true))
          [mui/card-content {}
           [:br]
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [mui/typography {} "Lade Daten ... "]
           ]
          )
        (do

          (if @!open-question
            [question-detail-form/question-form !open-question reload-fn]
            (do
              [:div
               (log/debug "questions " @!questions)
               [mui/card-content {}
                [mui/grid
                 {:container  true
                  :direction  "row"
                  :alignItems "stretch"
                  :justify    "flex-start"

                  }

                 (doall (for [[uuid question] (sort-by (fn [[uuid n]] (:questionnaireQuestion-index n))
                                                       (filter (fn [[_ e]] (:questionnaireQuestion-active e)) @!questions))]
                          ^{:key (str "question-" uuid)}
                          [mui/grid
                           {:container false
                            :item true
                            :xs 12  ;extra-small: 0px
                            :style {:textAlign "left" :backgroundColor "#e6e6e6"}
                            }
                           [(question-card question !open-question @!questions reload-fn)]
                           ]
                          ))
                 ]
                ]
               [mui/card-actions

                [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                             :onClick  #(swap! vstate/app-state assoc
                                               :edit-questionnaire {}
                                               :questionnaire-detail-loaded false
                                               :site :questionnaire-list
                                               )
                             }
                 "Schließen"
                 ]
                [create-with-name-modal/modal !show-add-popup "Neue Frage hinzufügen" "hinzufügen"
                 (fn [name]
                   (d-questionnaire/>questionnaire-add-new-question (:questionnaireQuestionnaire-uuid @!questionnaire) name (inc (get-max-index @!questions)) reload-fn)
                   (reset! !open-question (:questionnaireQuestionnaire-uuid @!questionnaire))
                   )]

                [mui/button {:startIcon (r/as-element [add])
                             :onClick #(reset! !show-add-popup true)
                             }
                 "Neue Frage hinzufügen"
                 ]

                ]
               ])))

        )
      )))